import { healthColor } from "../lib/format";

export function HealthRing({ score, size = 132, stroke = 12 }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = score ? Math.max(0, Math.min(100, score)) : 0;
  const offset = c - (pct / 100) * c;
  const color = healthColor(score || 0);
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid="health-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="hsl(40 15% 88%)" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.9s ease" }} />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-heading text-3xl font-bold tracking-tight" style={{ color }}>
          {score ?? "—"}
        </span>
        <span className="text-[0.65rem] text-muted-foreground uppercase tracking-widest">/ 100</span>
      </div>
    </div>
  );
}
